export default "__VITE_ASSET__DD94F$E$__"